// extracted by mini-css-extract-plugin
module.exports = {"HeaderNavLinks":"style_HeaderNavLinks__gCWw9","active":"style_active__1gcOp"};